// extracted by mini-css-extract-plugin
export default {"welcome":"Dashboard_welcome__j8Sa0","grid":"Dashboard_grid__gTE1Z","card":"Dashboard_card__akwJ8","cardIcon":"Dashboard_cardIcon__RQUFM","cardLabel":"Dashboard_cardLabel__XJ8QW"};